import type { JSX } from 'react';
import { useMemo, useState } from 'react';

import { Button } from '../ds';
import type { MyPlanEventDto } from '../../lib/api/openingTasks';
import { fmtWhen } from '../opening-tasks/utils';
import { sortEvents } from './plan-model';

/** Сколько событий показываем сразу и сколько добавляет «Показать ещё». */
export const FEED_PAGE = 20;

/** «Лента событий»: дата-время, текст, автор. Свежие сверху; первые 20, дальше — по кнопке. */
export function PlanFeed({ events }: { events: readonly MyPlanEventDto[] }): JSX.Element {
  const sorted = useMemo(() => sortEvents(events), [events]);
  const [shown, setShown] = useState(FEED_PAGE);
  const rest = sorted.length - shown;
  return (
    <section className="fk-op-card" aria-label="Лента событий">
      <div className="fk-op-h">Лента событий</div>
      {sorted.length === 0 ? (
        <div className="fk-ot-empty">Событий пока нет.</div>
      ) : (
        sorted.slice(0, shown).map((e) => (
          <div key={e.id} className="fk-op-ev">
            <span className="fk-op-av" data-system={!e.actorName} aria-hidden="true">
              {(e.actorName ?? 'С').trim().slice(0, 1).toUpperCase()}
            </span>
            <div className="fk-op-ev-body">
              <div className="fk-op-ev-who">
                <b>{e.actorName ?? 'Система'}</b>
                <time dateTime={e.createdAt}>{fmtWhen(e.createdAt)}</time>
              </div>
              {e.text ? <div className="fk-op-ev-text">{e.text}</div> : null}
            </div>
          </div>
        ))
      )}
      {rest > 0 ? (
        <div className="fk-op-more">
          <Button variant="ghost" size="sm" onClick={() => setShown((n) => n + FEED_PAGE)}>
            Показать ещё ({rest})
          </Button>
        </div>
      ) : null}
    </section>
  );
}
